// Svelte 5 no longer needs svelte/store imports for basic reactivity
import voiceUtils from "@cclib/providers/textToSpeechAll/voiceUtils.js";

function loadVoicesFromLocalStorage() {
    let voices = JSON.parse(localStorage.getItem("cc-voice-defaults")) || [];
    // Retired voices (Google Studio, Deepgram) are replaced; the replacement may duplicate an existing pin.
    let seen = new Set();
    return voices.map((voice) => {
        voice = voiceUtils.migrateVoice(voice);
        // ElevenLabs pins saved before model selection get the current model list as their styles
        if (voice.provider === "ElevenLabs") voice = { ...voice, styles: voiceUtils.elevenLabsStyles() };
        return voice;
    }).filter((voice) => {
        let key = voiceUtils.voiceKey(voice);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}

// Create reactive state for voices
export const voiceState = $state(loadVoicesFromLocalStorage());